// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"fc203570","320":"b2432cdd","583":"488afaca","688":"d272085e","945":"fbe8c60b"}[chunkId] + ".chunk.js";
};